import ThemeButton from "../ThemeButton";
import { SxProps, Theme } from "@mui/material";
import { useGoogleAnalyticsContext } from "contexts";
import { useLinks } from "hooks/useLinks";

interface BackToGameButtonProps {
	children?: React.ReactNode;
	styles?: React.CSSProperties;
	sx?: SxProps<Theme> | undefined;
	source: string;
	onClick?: () => void;
	themeColor?: "primary" | "secondary";
}

const BackToGameButton = ({
	children = "Return to Game",
	styles,
	sx,
	source,
	onClick,
	themeColor = "primary"
}: BackToGameButtonProps) => {
	const links = useLinks();
	const { analytics_key, path } = links.back_to_game;
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const handleClick = () => {
		reportEvent(analytics_key, { source: source });
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: analytics_key,
			event_type: source,
			action: analytics_key,
			source
		});
		window?.open(path, "_blank");
		onClick?.();
	};

	return (
		<ThemeButton
			themeColor={themeColor}
			onClick={handleClick}
			style={{ textTransform: "none", ...styles }}
			sx={sx}
		>
			{children}
		</ThemeButton>
	);
};

export default BackToGameButton;
